// extracted by mini-css-extract-plugin
export var altaccent = "BoxContent-module--altaccent--d8775";
export var bottomAlign = "BoxContent-module--bottom--align--802d8";
export var bounds = "BoxContent-module--bounds--06d96";
export var box = "BoxContent-module--box--85fb3";
export var content = "BoxContent-module--content--8cc2d";
export var ltr = "BoxContent-module--ltr--3acac";
export var rtl = "BoxContent-module--rtl--b0ee2";
export var topAlign = "BoxContent-module--top--align--175a8";
export var visual = "BoxContent-module--visual--48436";